import React, { useContext, useState, useEffect, useRef } from 'react';
import {Table, Input, Button, Form, Space} from 'antd';

const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

const EditableCell = ({
                          title,
                          editable,
                          children,
                          dataIndex,
                          record,
                          handleSave,
                          ...restProps
                      }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };

    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };

    let childNode = children;

    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: false,
                        message: `${title} is required.`,
                    },
                ]}
            >
                <Input style={{width:100}} ref={inputRef} onPressEnter={save} onBlur={save} />
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }

    return <td {...restProps}>{childNode}</td>;
};

class CreateTable extends React.Component {
    constructor(props) {
        super(props);
        this.columns=[
            {
                title: 'Message',
                dataIndex: 'message',
                editable: true,
                render:(text, record, index)=>{
                    record.message=text
                    if(!text){
                        return <Input style={{width:100}} />
                    }else{
                        return  text
                    }
                }
            },
            {
                title: 'Material',
                dataIndex: 'partNumber',
                editable: true,
                render:(text, record, index)=>{
                    record.partNumber=text
                    if(!text){
                        return <Input style={{width:100}} />
                    }else{
                        return  text
                    }
                }
            },
            {
                title: 'Quantity',
                dataIndex: 'quantity',
                editable: true,
                render:(text, record, index)=>{
                    record.quantity=text
                    if(!text){
                        return <Input style={{width:100}} />
                    }else{
                        return  text
                    }
                }
            },
            {
                title: 'End User Name',
                dataIndex: 'endUserName',
                editable: true,
                render:(text, record, index)=>{
                    record.endUserName=text
                    if(!text){
                        return <Input style={{width:100}} />
                    }else{
                        return  text
                    }
                }
            },
            {
                title: 'Unit Claim Value',
                dataIndex: 'unitClaimValue',
                editable: true,
                render:(text, record, index)=>{
                    record.unitClaimValue=text
                    if(!text){
                        return <Input style={{width:100}} />
                    }else{
                        return  text
                    }
                }
            },
            {
                title: 'Claim Value',
                dataIndex: 'claimValue',
                editable: true,
                render:(text, record, index)=>{
                    record.claimValue=text
                    if(!text){
                        return <Input style={{width:100}} />
                    }else{
                        return  text
                    }
                }
            },
            {
                title: 'Serial Number',
                dataIndex: 'serialNumber',
                editable: true,
                render:(text, record, index)=>{
                    record.serialNumber=text
                    if(!text){
                        return <Input style={{width:100}} />
                    }else{
                        return  text
                    }
                }
            },
        ]
        // this.columns =  this.columns.filter((v)=>{
        //     return v.dataIndex !== 'status' && v.dataIndex !== 'invoiceNo';
        // });
        this.state = {
            count:null,
            selectedRowKeys:[],
            dataSource: [],
        };
    }

    handleDelete = () => {
        const {selectedRowKeys}=this.state;
        const dataSource = [...this.state.dataSource];
        selectedRowKeys.map((json)=>{
            // dataSource.filter(item => item.serialNumber!=json)
            console.log(dataSource.filter(item => item.serialNumber!=json))
            this.setState({
                dataSource: dataSource.filter(item => item.serialNumber!=json),
            });
        })

        // this.setState({
        //     dataSource: dataSource.filter((item) => item.key !== selectedRowKeys),
        // });
    };
    handleAdd = () => {
        const { count, dataSource } = this.state;
        const newData = {
            key: this.state.dataSource.length+1,
            message:'',
            partNumber:'',
            quantity:'',
            endUserName:'',
            unitClaimValue:'',
            claimValue:'',
            serialNumber:''
        };
        this.setState({
            dataSource: [...dataSource, newData],
            count: count + 1,
        });
    };
    handleSave = (row) => {
        const newData = [...this.state.dataSource];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        this.setState({
            dataSource: newData,
        });
        this.props.changeData(newData)
    };
    onSelectChange = (selectedRowKeys,selectedRows) => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        console.log('selectedRows changed: ', selectedRows);
        this.setState({ selectedRowKeys });
    };

    render() {
        const { dataSource,selectedRowKeys } = this.state;
        const {data} = this.props;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const components = {
            body: {
                row: EditableRow,
                cell: EditableCell,
            },
        };
        const columns = this.columns.map((col) => {
            if (!col.editable) {
                return col;
            }

            return {
                ...col,
                onCell: (record) => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: this.handleSave,
                }),
            };
        });
        return (
            <div>
                <Table
                    style={{paddingRight:24}}
                    scroll={{x: 1400,y: 500}}
                    components={components}
                    rowKey={'serialNumber'}
                    rowClassName={() => 'editable-row'}
                    bordered
                    dataSource={data && data.length?data:dataSource}
                    columns={columns}
                    rowSelection={rowSelection}
                />
                <Space>
                    <Button
                        onClick={this.handleAdd}
                        type="primary"
                        style={{
                            marginBottom: 16,
                        }}
                    >
                        Add Item
                    </Button>
                    <Button
                        onClick={this.handleDelete}
                        type="primary"
                        style={{
                            marginBottom: 16,
                        }}
                    >
                        Delte Item
                    </Button>
                </Space>
            </div>
        );
    }
}
export default CreateTable;